const Hero = () => {
  return (
    <section id="home" className="relative w-full h-screen overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/d975884ffe2514a0a224ba62f333db56/7bae75f5e4312e57efe7eb72a97b4192.png"
          alt="MBJET Jet Boat Adventure Mission Beach"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-center h-screen px-8 md:px-16 w-full text-center">
        <div className="max-w-4xl w-full">

          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img
              src="https://public.readdy.ai/ai/img_res/29f8fb6e-0e57-4a7c-9167-87517f4a1fef.png"
              alt="MBJET Logo"
              className="h-36 md:h-48 w-auto object-contain drop-shadow-2xl"
            />
          </div>

          {/* Main headline */}
          <h1 className="text-white font-black leading-none mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
            <span className="block text-[28px] md:text-[38px] leading-snug text-white/95 tracking-wide">
              HOLD ON TIGHT FOR AN EXHILARATING 30-MINUTE
            </span>
            <span className="block text-[28px] md:text-[38px] leading-snug text-white/95 tracking-wide">
              JET BOAT EXPERIENCE
            </span>
          </h1>

          {/* Feature list */}
          <p className="text-[#00E5CC] text-lg md:text-2xl font-black tracking-widest mb-2">
            FULL 360° SPINS &bull; WAVE SURFING &bull; FISH-TAILS &bull; HIGH-SPEED DRIFTING
          </p>
          <p className="text-white/90 text-lg md:text-xl font-bold italic mb-10 tracking-wide">
            Fast, Fun, and Unforgettable.
          </p>

          {/* Pricing block */}
          <div className="inline-flex items-center gap-6 bg-black/50 border border-white/20 backdrop-blur-sm rounded-2xl px-8 py-5 mb-10">
            <div className="text-center">
              <div className="text-white/60 text-xs font-black tracking-widest uppercase mb-1">Adults</div>
              <div className="text-[#FF6B35] font-black text-4xl leading-none" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>$80</div>
            </div>
            <div className="w-px h-12 bg-white/20" />
            <div className="text-center">
              <div className="text-white/60 text-xs font-black tracking-widest uppercase mb-1">Children (Under 12)</div>
              <div className="text-[#00E5CC] font-black text-4xl leading-none" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>$60</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="tel:0435075589"
              className="flex items-center gap-3 bg-[#FF6B35] hover:bg-[#FF8C42] text-white font-black text-lg px-10 py-5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap hover:scale-105"
            >
              <i className="ri-ship-2-fill text-xl" />
              BOOK YOUR RIDE
            </a>
            <a
              href="tel:0435075589"
              className="flex items-center gap-3 border-2 border-[#00E5CC] text-[#00E5CC] hover:bg-[#00E5CC] hover:text-black font-black text-lg px-10 py-5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl" />
              0435 075 589
            </a>
          </div>

          {/* Tagline */}
          <p className="text-white/50 text-sm font-semibold mt-8 italic tracking-widest">
            "Mbjet Got Me Wet" &mdash; www.mbjet.com.au
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
